module.exports = __webpack_public_path__ + "img/google_icon.dfd7d2e7.svg";